import styles from './invitation.module.scss'
import React, { useState, useEffect, useRef } from 'react'

import { compare } from 'utils'

//antd
import { Input, Row, Col, Table, Button, Popconfirm, notification, Select } from 'antd'
import exportCSV from 'components/ExportCSV/export'


//apis
import { getInvitations } from 'apis/invitation'
import { ToTopOutlined } from '@ant-design/icons'
const HOST_LINK_COMMENT = 'https://elgaucho.asia'


export default function Branch() {
  // const typingTimeoutRef = useRef(null)
  // const { Option } = Select

  const [loading, setLoading] = useState(false)
  const [invitations, setInvitations] = useState([])
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  
  const [countInvitations, setCountInvitations] = useState(0);

  const _getInvitation = async () => {
    try {
      const res = await getInvitations({ ...paramsFilter })
      if (res.status === 200) {
         setInvitations(res.data.data)
         setCountInvitations(res.data.count)
      }
    } catch (e) {
      console.log(e)
    }
  }


  useEffect(() => {
    _getInvitation()
  }, [paramsFilter])

  const _getCustomerToExport = async () => {
    let dataExport = []
    try {
      setLoading(true)
      const res = await getInvitations({page: 1, page_size:2000000})
      if (res.status === 200) {
        dataExport = res.data.data.map((item, index) => { 
          let guestsArrived = item.customers_arrived ? item.customers_arrived.join('\n') : '';
          var info = "";
          if( item.guests) {
            var infoguests = item.guests.map((guest, index) => {
              let name = "Tên khách "+ (index +1) + ": " + guest.name  ; 
              let email =    "Email khách "+ (index +1) + ": " + guest.email ; 
              return name + "\n" + email;
            });
            info = infoguests.join("\n");
          }
          
          return ({
            STT: index + 1,
            'Tên khách hàng': (item.full_name || ''),
            // 'Loại khách hàng': item._type ? item._type.name : '',
            'Số điện thoại': item.phone_number || '',
            'Email': item.email || 0,
            // 'Điểm tích luỹ': item.point || 0,
            // 'Số điểm đã dùng': item.used_point || 0,
            // 'Tổng chi tiêu tại cửa hàng': item.order_total_cost || 0,
            'Số lượng khách đi cùng': item.number_guest,
            //item.create_date ? moment(item.create_date).format('DD-MM-YYYY HH:mm') : '',
            'Date event': item.date_event || '',
            'Số lượng khách tới party': guestsArrived,
            'Total khách tới party': item.customers_arrived ? item.customers_arrived.length : 0,
            'Thông tin khách đi cùng': info,
            // 'Địa chỉ': `${item.address && item.address + ', '}${
            //   item.district && item.district + ', '
            // }${item.province && item.provinc
          });
        })
      }
      setLoading(false)
      exportCSV(dataExport, 'Danh sách khách hàng invitation')
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      //render: (text, record, index) =>(<></>)
    },
    {
      title: 'Name',
      dataIndex: 'full_name',
      // render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      render: (text, record, index) =>(<div>{text}</div>),
     
    },
    {
      title: 'Phone',
      dataIndex: 'phone_number',
      render: (text, record, index) =>(<div>{text}</div>),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      render: (text, record, index) =>(<div>{text}</div>),
    },
    {
      title: 'Number guest',
      dataIndex: 'number_guest',
      render: (text, record, index) =>(<div>{text}</div>),
    },
    {
      title: 'Date event',
      dataIndex: 'date_event',
      render: (text, record, index) =>(<div>{text}</div>),
    },
    {
      title: 'Guest information',
      render: (text, record) => (
      <div style={{maxWidth: '300px'}}>{record.guests && record.guests.map((guest, index) => {
        let name = "Name Guest "+ (index +1) + ": " + guest.name  ; 
        let email =    "Email Guest "+ (index +1) + ": " + guest.email ; 
        return <>{name}<br/>{email}<br/></>
      })}</div>),
    },
    {
      title: 'Guest arrived',
      render: (text, record) => (
      <div style={{maxWidth: '300px'}}>{record.customers_arrived && record.customers_arrived.map((customer_arrived_email, index) => {
        let email = customer_arrived_email; 
        return <>{email}<br/></>
      })}</div>),
    },
    {
      title: 'Total guest',
      render: (text, record) => (
      <div style={{maxWidth: '300px'}}>{(isNaN(Number(record.number_guest)) ? 0 : Number(record.number_guest))  +1}</div>),
    },
    {
      title: 'Total Guest arrived',
      render: (text, record) => (
        <div style={{maxWidth: '300px'}}>{record.customers_arrived && record.customers_arrived.length}</div>),
    },
    {
      title: 'Location',
      render: (text, record) => (
        <div style={{maxWidth: '300px'}}>{record.location && record.location.name}</div>),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text, record, index) =>(<div>{text}</div>),
    },
  ]



  useEffect(() => {
    _getInvitation();
  }, [])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem',width: '100%' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý invitations</div>
        <Button
              onClick={_getCustomerToExport}
              size="large"
              type="primary"
              icon={<ToTopOutlined />}
            >
              Xuất Excel
            </Button>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={invitations}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          // position: ['bottomLeft'],
          // current: paramsFilter.page,
          // pageSize: paramsFilter.page_size,
          // pageSizeOptions: [20, 30, 40, 50, 70, 100],
          // showQuickJumper: true,
          // onChange: (page, pageSize) =>
          //   setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          // total: countInvitations,
          current: paramsFilter.page,
            pageSize: paramsFilter.page_size,
            pageSizeOptions:  [20, 30, 40, 50, 70, 100],
            showQuickJumper: true,
            onChange: (page, pageSize) => {
              paramsFilter.page = page
              paramsFilter.page_size = pageSize

              setParamsFilter({ ...paramsFilter })
            },
            total: countInvitations,
        }}
      />
      
    </div>
  )
}
